import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import s from '../../IconV2.scss';

const Facebook24: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(
      chroma === 'dark' ? s.svgLight24 : s.svgDark24,
      `svg-icon--${icon}`
    )}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    data-icon={chroma === 'dark' ? `${icon}-24-solid` : `${icon}-24`}
  >
    <path
      d="M17 9.592h-3.299V7.179c0-.74.764-.91 1.12-.91h2.132V3.012L14.51 3c-3.332 0-4.093 2.427-4.093 3.983v2.609H8v3.354h2.418V22H13.7v-9.054h2.79L17 9.592z"
      fillRule="evenodd"
    />
  </svg>
);

export default Facebook24;
